/* eslint-disable no-plusplus */
// Utils
import { uniq, isArray } from 'lodash';
import getCampNumberOfDays from '../utils/package/getCampNumberOfDays';
import packageUtils from '../utils/package/packageUtils';

const useFilters = () => {
  const getPackIdsByThemes = (filters, themes) => {
    // get packages ids for each selected theme
    const filteredList = filters.themesIds.map((themeId) => {
      const rawData = themes.find((th) => th.id === themeId);
      return rawData?.packageIds || null;
    }).filter(isArray);

    // remove duplicate ids
    return uniq(filteredList.flat());
  };

  const getPackIdsByFilter = (filterSelection, filterName, allPackages) => {
    const isFilterArray = isArray(allPackages?.[0]?.[filterName]);

    const packIds = allPackages
      .filter((pack) => {
        const packFilterValue = pack[filterName];

        if (isFilterArray) {
          return packFilterValue.some((value) => filterSelection.includes(value));
        }

        return filterSelection.includes(packFilterValue);
      })
      .map((pack) => pack.id);

    return uniq(packIds);
  };

  const getFilteredList = (
    list,
    filters,
    rawThemes,
    rawPackages,
    rawOffers,
    selectedPackageOnInit,
    currentPlayerId,
    firstPlayer,
  ) => {
    const packagesByType = list?.filter((item) => (filters?.typeId && item.typeId === filters.typeId)) || [];

    let packagesIdsByTheme = null;
    let packagesIdsBySports = null;
    let packagesIdsByTags = null;
    let packagesIdsByFormat = null;

    const weeksSelection = isArray(filters.weekIds) ? filters.weekIds : [filters.weekIds];

    const packagesListBySelection = filters?.weekIds && filters?.durationId
      ? packageUtils.getPackagesFromUserWeeksSelection(
        rawPackages,
        rawOffers,
        weeksSelection,
        filters.durationId === 2,
      )
      : packagesByType;

    // if current player is not the first one
    // apply filter on the list to display only same duration camps
    let packagesByNumberOfDays = packagesListBySelection || [];

    if (currentPlayerId !== 1 && firstPlayer?.stage?.days) {
      packagesByNumberOfDays = (packagesListBySelection || []).filter(
        (pack) => getCampNumberOfDays(pack) === firstPlayer.stage.days,
      );
    }

    if (selectedPackageOnInit) {
      packagesByNumberOfDays.sort(
        (a, b) => (a.id === selectedPackageOnInit ? -1 : b.id === selectedPackageOnInit ? 1 : 0),
      );
    }

    // if current player is not the first one
    // remove sold out packages from list
    if (currentPlayerId && currentPlayerId !== 1) {
      packagesByNumberOfDays = packagesByNumberOfDays.filter((pack) => {
        if (
          pack.offers?.length
          && weeksSelection?.length
          && pack.offers.length !== weeksSelection.length
        ) {
          // if one of the selected week is inactive in stock, remove package from list
          return false;
        }
        const hasSoldOutOffer = pack.offers?.some((o) => o.flag === 'SOLD_OUT');
        return !hasSoldOutOffer;
      });
    }

    // THEMES
    packagesIdsByTheme = filters?.themesIds?.length
      && getPackIdsByThemes(filters, rawThemes);

    // SPORTS
    packagesIdsBySports = filters?.sportIds?.length
      && getPackIdsByFilter(filters.sportIds, 'sportIds', packagesByNumberOfDays);

    // TAGS
    packagesIdsByTags = filters?.tagIds?.length
      && getPackIdsByFilter(filters.tagIds, 'tagIds', packagesByNumberOfDays);

    // FORMAT
    packagesIdsByFormat = filters?.formatId
      && getPackIdsByFilter([filters?.formatId], 'formatId', packagesByNumberOfDays);

    // return list by user weeks selection, player type and all active filters
    const result = packagesByNumberOfDays
      .filter((p) => filters?.typeId && filters.typeId === p.typeId)
      .filter((p) => {
        if (packagesIdsByTheme && !packagesIdsByTheme.includes(p.id)) {
          return false;
        }
        if (packagesIdsBySports && !packagesIdsBySports.includes(p.id)) {
          return false;
        }
        if (packagesIdsByTags && !packagesIdsByTags.includes(p.id)) {
          return false;
        }
        if (packagesIdsByFormat && !packagesIdsByFormat.includes(p.id)) {
          return false;
        }
        return true;
      });

    return result;
  };

  return {
    getFilteredList,
  };
};

export default useFilters;
